import { render, staticRenderFns } from "./info.vue?vue&type=template&id=066f8e15&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=066f8e15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f8e15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066f8e15')) {
      api.createRecord('066f8e15', component.options)
    } else {
      api.reload('066f8e15', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=066f8e15&scoped=true&", function () {
      api.rerender('066f8e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/info.vue"
export default component.exports